
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/campaign-intelligence/metrics",
      function () {
        return require("private-next-pages/campaign-intelligence/metrics.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/campaign-intelligence/metrics"])
      });
    }
  